import React from "react";

export function PhoneNumberInput({phoneNumber,onChange}) {

    return <section>
        <label className="input">
            <i className="icon-append fa-phone"></i>
            <input type="text" id="phone_no" data-toggle="tooltip" data-placement="bottom" placeholder="Unesi broj"
                   data-original-title="npr. 06X XXX XXX"
                   pattern="\d{3}\s*(\d+\s*)+"
                   value={phoneNumber}
                   onChange={(event) => onChange && onChange(event.target.value)}
                   required="required"
                   ng-click="phoneFieldClicked()"
                   ng-blur="phoneFieldBlur()"/>
            <b className="tooltip tooltip-bottom-right">Npr. 06X XXX XXX</b>
        </label>
    </section>

}